import { ActionType, createAction } from 'typesafe-actions';

export const AppActions = {
    showMainMenu: createAction('app/SHOW_MENU')<boolean>(),
};

export type AppActions = ActionType<typeof AppActions>;
